module.exports = __webpack_public_path__ + "img/missing.6fef2bb2.svg";